import React from 'react';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import EmailLinksTooltip from '../email-links-tooltip';

const useStyles = makeStyles(() => ({
    officeButton: {
        display: 'inline-block',
        outline: 'none',
        cursor: 'pointer',
        textAlign: 'center',
        textDecoration: 'none',

        '&:hover': {
            textDecoration: 'none',
        },
        '&.active': {
            position: 'relative',
            top: '1px',
        },

        padding: '12px 20px',
        color: '#ffffff',
        background: 'linear-gradient(0deg, #377EFC 0%, #7EB1F0 100%)',
        border: '1px solid rgba(44, 94, 189, 0.3)',
        borderRadius: '4px',

        fontFamily: 'Nunito Sans',
        fontStyle: 'normal',
        fontWeight: '700',
        fontSize: '14px',
        lineHeight: '100%',
    },
}));

/**
 * The blue gradient button used by Microsoft Office 365
 *
 * Takes in functions related to link functionality, so it can handle...link functionality :)
 */
const OfficeButtonLink = ({
    link,
    handleLinkClick,
    handleLinkMouseEnter,
    handleLinkMouseLeave,
    isHoveringOnLink,
}) => {
    const { t } = useTranslation('assessment');
    const classes = useStyles();

    return (
        <span
            className={classes.officeButton}
            onClick={() => handleLinkClick(link.clickActionId)}
            onMouseEnter={handleLinkMouseEnter}
            onMouseLeave={handleLinkMouseLeave}
        >
            {t(link.text)}
            <EmailLinksTooltip isVisible={isHoveringOnLink} text={link.href} />
        </span>
    );
};

export default OfficeButtonLink;
